<script setup lang="ts">
/*
 * Empty / error state panel: icon in a flat disc, title, one line of body,
 * and an optional primary action (link or `#action` slot).
 */
import type { Component } from 'vue';
import { RouterLink } from 'vue-router';

defineProps<{
  icon: Component;
  title: string;
  body?: string;
  to?: string;
  actionLabel?: string;
  tone?: 'default' | 'error';
  /** Pulsing ring instead of floating: a state that is still in progress. */
  pulse?: boolean;
}>();
</script>

<template>
  <div v-reveal class="surface relative flex flex-col items-center overflow-hidden px-6 py-16 text-center">
    <span
      class="mb-5 flex h-16 w-16 items-center justify-center rounded-full"
      :class="[pulse && 'animate-pulse-ring', tone === 'error' ? 'bg-error text-text-inv' : pulse ? 'bg-mint text-text-inv' : 'bg-accent text-text-inv']"
    >
      <component :is="icon" class="h-6 w-6" aria-hidden="true" />
    </span>
    <p class="font-heading text-[22px] font-black text-text-base">{{ title }}</p>
    <p v-if="body" class="mt-2 max-w-[42ch] text-[14px] leading-relaxed text-text-dim">{{ body }}</p>
    <div v-if="to || $slots.action" class="mt-6">
      <slot name="action">
        <RouterLink v-if="to" :to="to" class="btn-primary">{{ actionLabel }}</RouterLink>
      </slot>
    </div>
  </div>
</template>
